import { createI18n } from 'vue-i18n'
import cs from '@/locales/cs.json'
import en from '@/locales/en.json'
// import ua from '@/locales/ua.json'
import {
  en as vEn,
  cs as vCs,
  // uk as vUa,
} from 'vuetify/locale'

const saved = localStorage.getItem('locale') || 'cs'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: saved,
  fallbackLocale: 'en',
  messages: {
    cs: { ...cs, $vuetify: vCs },  
    en: { ...en, $vuetify: vEn },
    // ua: { ...ua, $vuetify: vUa },
  },
})

export function setLocale(l) {
  i18n.global.locale.value = l
  localStorage.setItem('locale', l)
}

export default i18n
